import { createSelector } from "reselect";
import { head, path } from "ramda";

export const watchListEntriesSelector = path([
  "watchListEntriesHighRiskCountry",
  "entries",
]);

export const watchListEntriesLoadingSelector = path([
  "watchListEntriesHighRiskCountry",
  "isLoading",
]);

export const watchListEntriesFiltersSelector = path([
  "watchListEntriesHighRiskCountry",
  "filters",
]);

export const highRiskCountriesNoEntriesMessageSelector = path([
  "watchListEntriesHighRiskCountry",
  "noEntriesMessage",
]);

export const highRiskCountriesIsLoadingSelector = path([
  "createHighRiskCountry",
  "isLoading",
]);

export const updateWatchListEntrySelector = createSelector(
  watchListEntriesSelector,
  head,
);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/selectors/index.js